import { SvgIcon } from "@progress/kendo-react-common";
import { hyperlinkOpenIcon } from "@progress/kendo-svg-icons";
import { Link } from "react-router-dom";
import { useUserContext } from "../../../hooks/useUserContext";

interface IMarginNameCellProps {
  name?: string;
  marginId?: number;
  marginCompanyId?: number;
}

export const MarginNameCell = ({ name, marginId, marginCompanyId }: IMarginNameCellProps) => {
  const { context: user } = useUserContext();

  if (!name) return null;

  const isOwnMargin =
    !!marginId && marginCompanyId === user.activeCompany.id && user.permissions.canConfigureMargins;

  if (!isOwnMargin) return <span>{name}</span>;

  return (
    <Link
      target="_blank"
      to={`/admin/margin/${marginId}`}
      className="k-color-primary"
      style={{ textDecoration: "underline", display: "inline-flex", alignItems: "center", gap: 4 }}
    >
      {name}
      <SvgIcon icon={hyperlinkOpenIcon} size="small" />
    </Link>
  );
};
